import ModalCustom from '../../UI/modal';
import Button from '../../UI/button';

type Props = {
  show: boolean;
  handleClose: () => void;
  handleDelete?: () => void;
  title: string;
  header?: string;
  children?: React.ReactNode;
};

const DeleteModal = ({
  show,
  handleClose,
  handleDelete,
  title,
  header,
  children
}: Props) => {
  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title={title}
    >
      {children && <div className='mb-3'>{children}</div>}
      <div className='d-flex justify-content-between align-items-center'>
        <Button
          width={180}
          size='md'
          variant='dark'
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          width={180}
          size='md'
          variant='primary'
          onClick={handleDelete}
        >
          Delete
        </Button>
      </div>
    </ModalCustom>
  );
};
export default DeleteModal;
